import { Box, Typography, TypographyProps } from '@mui/material';
import type { SxProps, Theme } from '@mui/system';
import React, { MouseEventHandler } from 'react';
import { useI18n } from '../../i18n/I18n';

type OverflowMoreProps = {
    count: number;
    onClick?: MouseEventHandler;
    variant?: TypographyProps['variant'];
    usePrimaryColor?: boolean;
    sx?: SxProps<Theme>;
};

export default function OverflowMore({ count, onClick, variant, usePrimaryColor = false, sx }: OverflowMoreProps) {
    const moreLabel = useI18n('product.infoTile.more');

    if (count <= 0) {
        return null;
    }

    return (
        <Box sx={{ width: 'fit-content', display: 'inline' }}>
            <Typography
                component="span"
                variant={variant}
                className={onClick ? 'clickable' : undefined}
                onClick={onClick}
                sx={[
                    {
                        whiteSpace: 'nowrap',
                        ml: 0.5,
                        ...(usePrimaryColor && { color: 'primary.main' }),
                        ...(onClick ? { cursor: 'pointer' } : {})
                    },
                    ...(Array.isArray(sx) ? sx : sx ? [sx] : [])
                ]}
            >
                {`+${count} ${moreLabel}`}
            </Typography>
        </Box>
    );
}
